/*
 * Copyright (C) 2026 to Present Applause App Quality, Inc. All rights reserved.
 */

// After "View more", moves focus to the first new item once it has rendered, so keyboard users carry on
// where the list grew instead of back at the button.
export function focusNewItem(host: HTMLElement, selector: string): void {
  setTimeout(() => host.querySelector<HTMLElement>(selector)?.focus());
}
